import {IS_MAC} from '~ui/constants';

// pick only needed props from mouse event, so this function could be used with native
// and react (synthetic) events
type GeneralMouseEvent = Pick<MouseEvent, 'button' | 'metaKey' | 'ctrlKey' | 'shiftKey'>;

export const isDefaultLinkBehavior = (e: GeneralMouseEvent) => {
    const openInNewTab = IS_MAC ? e.metaKey : e.ctrlKey;
    const openInNewWindow = e.shiftKey;
    const isMiddleClick = e.button === 1;

    return openInNewTab || openInNewWindow || isMiddleClick;
};
